import createReducer, { createCollectionStatusReducer } from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const status = createCollectionStatusReducer(
  ActionTypes.FETCH_THREAD_ERROR,
  ActionTypes.FETCH_THREAD_REQUEST,
  ActionTypes.FETCH_THREAD_SUCCESS
);

export const mergeMessages = (state, { payload }) => {
  const { id } = payload;
  const existing = state[id] ? state[id].messages : [];
  const toMerge = payload.messages || [];
  return {
    ...state,
    [id]: {
      id,
      messages: mergeArrayById(existing, toMerge)
    }
  };
};

export const updateMessage = (state, { payload }) => {
  const { id: idToUpdate, thread, message } = payload;
  const existing = state[thread].messages;
  return {
    ...state,
    [thread]: {
      id: thread,
      messages: [...existing.filter(m => m.id !== idToUpdate), message]
    }
  };
};

export const deleteMessage = (state, { payload }) => {
  const { thread, message } = payload;
  const existing = state[thread].messages;
  return {
    ...state,
    [thread]: {
      id: thread,
      messages: existing.filter(m => m.id !== message)
    }
  };
};

const mergeArrayById = (existing, toMerge) => {
  const oldKeyValue = existing.map(obj => [obj.id, obj]);
  const map = new Map(oldKeyValue);
  toMerge.forEach(obj => {
    const toAdd = map.has(obj.id) ? { ...map.get(obj.id), ...obj } : { ...obj };
    map.set(obj.id, toAdd);
  });
  return [...map.values()];
};

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_THREAD_SUCCESS]: mergeMessages,
    [ActionTypes.UPDATE_THREAD]: mergeMessages,
    [ActionTypes.UPDATE_MESSAGE]: updateMessage,
    [ActionTypes.DELETE_MESSAGE]: deleteMessage
  }
);

export default combineReducers({ status, list });
